<template>
  <div
    v-if="progressHandler && progressHandler.running"
    class="progress-tracker-container">
    <div class="progress-header">
      <LoaderSmall />
      <span>{{ progressHandler.currentStep }}</span>
    </div>
    <ProgressBar
      :progress="progressHandler.progress"
      :tooltip-content="progressHandler.currentStep"
      :show-percentage="false" />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import LoaderSmall from '@/common/components/controls/LoaderSmall.vue';
  import ProgressBar from '@/common/components/ui/ProgressBar.vue';
  import { ProgressHandler } from '@/common/components/ui/ProgressHandler';

  const progressHandler = ref<ProgressHandler>();

  function init(): ProgressHandler {
    progressHandler.value = new ProgressHandler();
    return progressHandler.value;
  }

  defineExpose({ init });
</script>

<style scoped lang="scss">
  .progress-tracker-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .progress-header {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }
</style>
